import React from 'react';

const baseStyle = {
  width: '100%',
  maxWidth: 400,
  padding: 40,
  background: 'rgba(10, 14, 39, 0.8)',
  borderRadius: 16,
  border: '1px solid rgba(0, 212, 255, 0.25)',
  boxShadow: '0 8px 32px rgba(0,0,0,0.4), 0 0 40px rgba(0, 212, 255, 0.1)',
  boxSizing: 'border-box',
};

/**
 * Painel com borda cyan e fundo escuro (login e blocos de formulário). Sobrescreva `style` para padding, `maxWidth` ou variantes em outras telas.
 */
export default function Card({ style, className, children, ...rest }) {
  const merged = {
    ...baseStyle,
    ...style,
  };

  return (
    <div className={className} style={merged} {...rest}>
      {children}
    </div>
  );
}
